export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q02_a.37ce6184.png";